import React from "react";
import { Button, Box } from "@mui/material";
import { Add } from "@mui/icons-material";

const FlowToolbar = ({ send }) => {
  return (
    <Box sx={{ position: "absolute", top: 10, left: 10, display: "flex", gap: 2 }}>
      <Button variant="contained" onClick={() => send("ADD_NODE")} startIcon={<Add />}>
        Adicionar Nó
      </Button>
    </Box>
  );
};

export default FlowToolbar;
